var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 7.27032C11.1218 7.27032 4.88432 11.0334 0.281682 17.1457C-0.0938938 17.6465 -0.0938938 18.3461 0.281682 18.8469C4.88432 24.9666 11.1218 28.7297 18 28.7297C24.8782 28.7297 31.1157 24.9666 35.7183 18.8542C36.0939 18.3535 36.0939 17.6539 35.7183 17.1531C31.1157 11.0334 24.8782 7.27032 18 7.27032ZM18.4934 25.5557C13.9276 25.8429 10.1571 22.0798 10.4443 17.5066C10.68 13.7361 13.7361 10.68 17.5066 10.4443C22.0724 10.1571 25.8429 13.9202 25.5557 18.4934C25.3127 22.2565 22.2565 25.3127 18.4934 25.5557ZM18.2651 22.065C15.8055 22.2197 13.7729 20.1945 13.9349 17.7349C14.0601 15.7024 15.7097 14.0601 17.7423 13.9276C20.2019 13.7729 22.2344 15.7981 22.0724 18.2577C21.9399 20.2976 20.2903 21.9399 18.2651 22.065Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_3294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSee);
export default __webpack_public_path__ + "static/media/see.fabbde4b582c9eb4714d1f6e6c215256.svg";
export { ForwardRef as ReactComponent };